import { IPaginator } from "common/types";

import { getSearchCountParts } from "../utils";

import styles from "../styles/SearchCount.module.less";

type SearchCountProps = {
  paginator?: IPaginator;
  entityName?: string;
};

/** "Showing 1 - 24 of **61 products**" above a list of results. */
const SearchCount = ({ paginator, entityName }: SearchCountProps) => {
  const [range, total] = getSearchCountParts(paginator, entityName);
  return (
    <span className={styles.count}>
      {range} <strong className={styles.total}>{total}</strong>
    </span>
  );
};

export default SearchCount;
